import React, {useContext, useEffect, useState} from 'react';
import {AreaLayerContext} from "../area-layer-context.jsx";

const AreasList = ({setShowPanel, setAreaSelected, cacheList}) => {
    const {areas} = useContext(AreaLayerContext)
    const [areasSelected, setAreasSelected] = useState([])

    const openArea = (area) => {
        setAreaSelected(area)
        setShowPanel(true)

        area.polygon.setOptions({
            editable: true,
            draggable: true,
        });
    }

    useEffect(() => {
        if (cacheList) {
            setAreasSelected(areas.filter(a => typeof a.id  === 'string'))
        } else {
            setAreasSelected(areas.filter(a => a.data.name))
        }
    }, [areas]);

    return (
        <>
            {
                areasSelected.map((a, index) => {
                    return(
                        <div key={index} onClick={() => openArea(a)} className={"mt-1 border border-[#e5e7eb] rounded-md flex justify-between px-2.5 h-8 cursor-pointer hover:bg-[#e7eaec]"}>
                            <div className={"flex items-center text-[13px] font-bold text-[#063A6C]"} title={a.data.name}>
                                {!a.data.name && <span className={`italic`}>Setor sem nome</span>}
                                {a.data.name && <span className={"truncate w-50"}>{a.data.name}</span>}
                            </div>
                        </div>
                    )
                })
            }
        </>
    );
};

export default AreasList;